import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ENV_TOKEN, EnvInterface} from 'env-config';
import {firstValueFrom} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private http = inject(HttpClient);
  private environment = inject(ENV_TOKEN) as EnvInterface;

  async login(username: string, password: string): Promise<any> {
    const url = this.environment.security.tuatara.endpoint;
    const apiKey = this.environment.security.tuatara.apiKey;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
    });
    const body = { Email: username, Password: password };
    return await firstValueFrom(this.http.post(url + '/account/login-by-credentials-jwt', body, {
      headers,
      withCredentials: true  // required for the browser to store the HttpOnly refresh cookie
    }));
  }
}
